export default __webpack_public_path__ + "static/google-maps-ddbb5c58bd12ea29bbd386e7d50eb0d8.png";